import clsx from "clsx";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { MenuProps } from "../menu/Menu";
import { Trash as DeleteIcon, Pencil as EditIcon } from "lucide-react";

import { GroupPostsEditDialog } from "./GroupPostsEditDialog";
import { useRemoveGroupPostMutation } from "./mutations/RemoveGroupPost";
import { GroupPostDto } from "@growth-machine-llc/stridist-api-client";
import { ListMenu, ListMenuOption } from "../menu/ListMenu";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

export interface GroupPostMenuProps extends MenuProps {
  post: GroupPostDto;
}

export function GroupPostMenu(props: GroupPostMenuProps) {
  const { className, post, ...other } = props;
  const { onClose } = props;
  const s = useStyles();
  const [openEditDialog, setOpenEditDialog] = React.useState(false);
  const { mutate: removeGroupPost } = useRemoveGroupPostMutation({
    groupId: post.groupId,
  });

  const { id, groupId } = post;

  const handleEdit = React.useCallback(
    (event) => {
      if (onClose) {
        onClose(event, "backdropClick");
      }
      setOpenEditDialog(true);
    },
    [onClose],
  );

  const handleEditClose = React.useCallback(() => {
    setOpenEditDialog(false);
  }, []);

  const handleDelete = React.useCallback(() => {
    removeGroupPost(id);
  }, [groupId, id, removeGroupPost]);

  const menuOptions: ListMenuOption[] = [
    {
      label: "Edit post",
      onClick: handleEdit,
      icon: <EditIcon />,
    },
    {
      label: "Delete post",
      onClick: handleDelete,
      icon: <DeleteIcon />,
    },
  ];

  return (
    <>
      <ListMenu
        className={clsx(s.root, className)}
        options={menuOptions}
        {...other}
      />
      {openEditDialog && (
        <GroupPostsEditDialog
          open
          groupId={groupId}
          post={post}
          onClose={handleEditClose}
        />
      )}
    </>
  );
}
